import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, Typography } from '@mui/material';
import { Product } from '@prisma/client';
import { FieldArray, Form, Formik } from 'formik';

import { useParams } from '@redwoodjs/router';

import { SelectedProducts } from 'src/hooks/usePricings';

import NPICurrencyInput from '../inputs/NPICurrencyInput/NPICurrencyInput';
import Spacer from '../Spacer';

interface ProductLimitProps {
    name: string;
    title: string;
    isAddRowButtonDisabled: boolean;
    product: SelectedProducts;
    onUpdateProduct: (updatedProduct: Product) => void;
}

const ProductLimit = ({
    name,
    title,
    isAddRowButtonDisabled,
    product,
    onUpdateProduct,
}: ProductLimitProps) => {
    const { id } = useParams();
    const initialValues = () => {
        if (id) {
            const { pricing } = product;
            return {
                [name]: pricing?.options[name].map(({ sales, commission }) => {
                    return {
                        sales,
                        commission,
                    };
                }),
            };
        }
        return {
            [name]: [
                {
                    sales: null,
                    commission: null,
                },
                {
                    sales: null,
                    commission: null,
                },
                {
                    sales: null,
                    commission: null,
                },
            ],
        };
    };

    return (
        <Formik
            initialValues={initialValues()}
            onSubmit={(values) => {
                return console.log(values);
            }}
        >
            {({ values }) => {
                const updatedProduct: Product = {
                    ...product,
                    pricing: {
                        ...product?.pricing,
                        options: {
                            ...product?.pricing?.options,
                        },
                        isUpdating: name,
                    },
                };

                return (
                    <Form>
                        <FieldArray
                            name={name}
                            render={(arrayHelpers) => {
                                return (
                                    <Stack
                                        spacing={1}
                                        width="100%"
                                        justifyContent="start"
                                        alignItems="start"
                                    >
                                        <Stack
                                            width="100%"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            flexDirection="row"
                                        >
                                            <Stack>
                                                <Typography variant="h3">{title}</Typography>
                                            </Stack>

                                            <Stack>
                                                <Button
                                                    disabled={isAddRowButtonDisabled}
                                                    onClick={() => {
                                                        return arrayHelpers.push({
                                                            sales: '',
                                                            commission: '',
                                                        });
                                                    }}
                                                    className="btn-medium-with-icon btn-dark"
                                                >
                                                    <AddIcon />
                                                    <Typography>Add Row</Typography>
                                                </Button>
                                            </Stack>
                                        </Stack>

                                        <Spacer padding={2} />

                                        <Stack
                                            justifyContent="space-evenly"
                                            width="100%"
                                            flexDirection="row"
                                        >
                                            <Stack width="100%">
                                                <Typography>No</Typography>
                                            </Stack>
                                            <Stack width="100%" alignItems="start">
                                                <Typography>Sales</Typography>
                                            </Stack>
                                            <Stack width="100%">
                                                <Typography>Commission</Typography>
                                            </Stack>
                                        </Stack>

                                        <Spacer padding={1} />

                                        {values[name].map((_, index) => {
                                            const handleValueChange = (
                                                field: string,
                                                index: number,
                                                valueInCents: number
                                            ) => {
                                                const currentValue = values[name][index][field];
                                                if (valueInCents !== currentValue) {
                                                    updatedProduct.pricing = {
                                                        ...updatedProduct.pricing,
                                                        options: {
                                                            ...updatedProduct.pricing.options,
                                                            [name]: updatedProduct.pricing.options[
                                                                name
                                                            ].map((option, i) => {
                                                                if (i === index) {
                                                                    return {
                                                                        ...option,
                                                                        [field]: valueInCents,
                                                                    };
                                                                }
                                                                return option;
                                                            }),
                                                        },
                                                    };
                                                    onUpdateProduct(updatedProduct);
                                                }
                                            };

                                            return (
                                                <Stack
                                                    justifyContent="space-evenly"
                                                    width="100%"
                                                    flexDirection="row"
                                                    key={index}
                                                >
                                                    <Stack width="50%">
                                                        <Typography>{index + 1}</Typography>
                                                    </Stack>
                                                    <Stack width="100%" flexDirection="row">
                                                        <NPICurrencyInput
                                                            name={`${name}[${index}].sales`}
                                                            disabled={isAddRowButtonDisabled}
                                                            defaultValueInCents={
                                                                values[name][index].sales
                                                            }
                                                            handleValue={(valueInCents) => {
                                                                handleValueChange(
                                                                    'sales',
                                                                    index,
                                                                    valueInCents
                                                                );
                                                            }}
                                                        />

                                                        <Spacer padding={1} />

                                                        <NPICurrencyInput
                                                            name={`${name}[${index}].commission`}
                                                            disabled={isAddRowButtonDisabled}
                                                            defaultValueInCents={
                                                                values[name][index].commission
                                                            }
                                                            handleValue={(valueInCents) => {
                                                                handleValueChange(
                                                                    'commission',
                                                                    index,
                                                                    valueInCents
                                                                );
                                                            }}
                                                        />
                                                    </Stack>
                                                </Stack>
                                            );
                                        })}
                                    </Stack>
                                );
                            }}
                        />
                    </Form>
                );
            }}
        </Formik>
    );
};
export default ProductLimit;
